
$(document).ready(function(){
  if($('.pdp_multicolumn__section').length > 0 && window.innerWidth < 750){
    $('.pdp_multicolumn__section .multicolumn-list').slick({
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg></button>'
    }); 
  }
  else{
    if($('.pdp_multicolumn__section .multicolumn-list-more-blocks').length > 0){
      $('.pdp_multicolumn__section .multicolumn-list.multicolumn-list-more-blocks').slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        adaptiveHeight: false,
        centerMode: false,
        prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg></button>',
        responsive: [
            {
              breakpoint: 1250,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 850,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1
              }
            }
          ]
      }); 
      let maxHeight = 0;
      $('.pdp_multicolumn__section .multicolumn-list.multicolumn-list-more-blocks .slick-slide').each(function () {
        const h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
      });
      $('.pdp_multicolumn__section .multicolumn-list.multicolumn-list-more-blocks .slick-slide').css('height', maxHeight);
    }
  }
  if ($(window).width() < 750) {
  const intervalgoal = setInterval(function () {
    const $goal = $('.cart__blocks .shopify-app-block .qbk-order-goal');
    
    if ($goal.length > 0) {
      $('.mobile__reward_bar').append($goal);
      clearInterval(intervalgoal); // Stop checking once appended
    }
  }, 300); // check every 300ms
}
})
